import axios from "axios";

export default {
  namespaced: true,
  state: {
    townships: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    townshipsMessage: ''
  },
  mutations: {
    CLEAR_TOWNSHIPS(state) {
      state.townships = [];
    },
    RECEIVED_TOWNSHIPS(state, payload) {
      state.townships = payload;
      state.isReceiving = false;
    },
    RECEIVING_TOWNSHIPS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TOWNSHIP(state, payload) {
      state = Object.assign(state, {
        townships: [...state.townships, payload],
        isReceiving: false,
      })
    },
    RECEIVING_TOWNSHIP(state) {
      state.isReceiving = true;
    },
    UPDATED_TOWNSHIP(state, payload) {
      let index = state.townships.findIndex(township => township._id === payload._id);
      state = Object.assign(state, {
        townships: state.townships.map((township, i) => {
          if (i === index) {
            return Object.assign({}, township, payload);
          }
          return township;
        }),
        isUpdating: false,
        townshipsMessage: 'Townships has been updating!',
      })
    },
    UPDATING_TOWNSHIP(state) {
      state.isUpdating = true;
    },
    DELETED_TOWNSHIP(state, payload) {
      let indexToDelete = state.townships.findIndex(township => township._id === payload._id);
      let townships = [...state.townships];
      townships.splice(indexToDelete, 1);
      state = Object.assign(state, {
        townships: [...townships],
        isDeleting: false,
        idToDelete: null,
        townshipsMessage: 'Township has been Deleted!',
      });
    },
    DELETING_TOWNSHIP(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getTownshipsRequest({dispatch}) {
      dispatch("receivingTownships");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/townships';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      return axios(get).then(res => {
        dispatch("receiveTownships", res.data);
      })
    },
    loadTownshipRequest({dispatch}, id) {
      dispatch("receivingTownship");
      axios.get('/townships/' + id).then(res => {
        dispatch("receiveTownship", res.data);
      })
    },
    updateTownshipRequest({dispatch}, payload) {
      dispatch("updatingTownship");
      var id = payload._id;
      delete payload['_id'];


      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/township/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateTownship", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateTownshipImageRequest({dispatch}, payload) {
      dispatch("updatingTownship");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/township/image/' + id;
      data = new FormData();
      data.append('image', payload.townshipimage, payload.imagename); 
      delete payload['townshipimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateTownship", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createTownshipRequest({dispatch}, payload) {
      dispatch("receivingTownships");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.townshipimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/township/withimage';
        data = new FormData();
        data.append('image', payload.townshipimage, payload.imagename); 
        delete payload['townshipimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.tradexc.com:3000/insert/township';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        dispatch("receiveTownship", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteTownshipRequest({dispatch}, payload) {
      dispatch("deletingTownship", payload);
      axios.get('https://api.tradexc.com:3000/delete/township/' + payload._id).then(() => {
        dispatch("deleteTownship", {_id: payload._id});
      })
    },
    clearTownships({commit}) {
      commit("CLEAR_TOWNSHIPS")
    },
    receiveTownships({commit}, payload) {
      commit("RECEIVED_TOWNSHIPS", payload)
    },
    receivingTownships({commit}) {
      commit("RECEIVING_TOWNSHIPS")
    },
    receiveTownship({commit}, payload) {
      commit("RECEIVED_TOWNSHIP", payload)
    },
    receivingTownship({commit}) {
      commit("RECEIVING_TOWNSHIP")
    },
    updateTownship({commit}, payload) {
      commit("UPDATED_TOWNSHIP", payload)
    },
    updatingTownship({commit}) {
      commit("UPDATING_TOWNSHIP")
    },
    deleteTownship({commit}, payload) {
      commit("DELETED_TOWNSHIP", payload)
    },
    deletingTownship({commit}, payload) {
      commit("DELETING_TOWNSHIP", payload)
    }
  },
};
